module.exports = __webpack_public_path__ + "static/fonts/gilroy-blackitalic-7.363e1fe.otf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/gilroy-blackitalic-7.otf
// module id = 2GAp
// module chunks = 36